import { defineStore } from 'pinia'

export const useDataStore = defineStore('datastore', {
  state: () => ({
    text: {},
    images: null,
    isLoading: false,
    error: null
  }),

  getters: {
    language() {
      return localStorage.getItem('lang') || 'hu'
    }
  },

  actions: {
    async fetchImages() {
      this.isLoading = true
      this.error = null

      try {
        const res = await fetch('/data/images.json', { cache: 'no-store' })
        this.images = await res.json()
      } catch (err) {
        this.error = 'Failed to fetch images'
        console.error(err)
      } finally {
        this.isLoading = false
      }
    }

  }
})
